import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/segmented-control/style/index.tsx